import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { buildRouteSlugBundle } from "../utils/i18nRoutes";
import enTranslations from "./locales/en/translations.json";
import frTranslations from "./locales/fr/translations.json";

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: "en",
    resources: {
      en: {
        translations: { ...enTranslations, _route: buildRouteSlugBundle("en") },
      },
      fr: {
        translations: { ...frTranslations, _route: buildRouteSlugBundle("fr") },
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
    saveMissing: true,
  })
  .then((r) => {})
  .catch((e) => console.error(e));

i18n.languages = ["en", "fr"];

export default i18n;
